module.exports = __webpack_public_path__ + "static/HF_WFSSC-a88eff911ce722cf0b7f48b67e7fc67f.png";